import { render, staticRenderFns } from "./AIKnow.vue?vue&type=template&id=e4ade7fa&scoped=true"
import script from "./AIKnow.vue?vue&type=script&lang=js"
export * from "./AIKnow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4ade7fa",
  null
  
)

export default component.exports